module.exports = Hwebsocket;


//////////////////
// WEBPACK FOOTER
// external "Hwebsocket"
// module id = 208
// module chunks = 30